import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/lang'
import myProject from './my-project.js'
import commonSetting from './common-setting.js'
import AccountManagement from './account-management'
import videoRecord from '@pt/router/video-record'
import creativeAssets from '@pt/router/creative-assets'
import creativeTemplate from './creative-template.js'
import creativeService from './creative-service.js'
import paymentPackage from './payment-package.js'
import subscriptionPlans from './subscription-plans.js'
import profile from './profile.js'
import dashboard from './dashboard.ts'
import demo from './demo.js'
import { generateConfigRoute } from '@com/utils/generateConfigRoute'
import PtLayout from '@pt/views/layout/index.vue'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/**
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/

export const routerMap = [
  {
    path: '/',
    component: PtLayout,
    redirect: '/login',
    name: 'website',
    meta: {
      title: 'Playturbo',
    },
    children: [],
  },
  {
    path: '/reset',
    component: () => import('@pt/views/profile/index.vue'),
    name: 'reset',
    meta: {
      title: '重置密码',
    },
  },
  {
    path: '/login',
    component: () => import('@pt/views/login/index.vue'),
    name: 'login',
    meta: {
      title: '登录页',
    },
  },
  {
    path: '/forget',
    component: () => import('@pt/views/login/forget.vue'),
    name: 'forget',
    meta: {
      title: '找回密码页',
      payment: 'free',
    },
  },
  {
    path: '/register',
    component: () => import('@pt/views/login/register.vue'),
    name: 'register',
    meta: {
      title: '账号注册页',
    },
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@pt/views/auth/index.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@pt/views/404.vue'),
  },
  {
    path: '/pl-viewer',
    name: 'pl-viewer',
    meta: {
      title: '预览导出页',
    },
    component: () => import('@pt/views/playable-viewer/index.vue'),
  },
  {
    path: '/pt-viewer',
    name: 'pt-viewer',
    component: () => import('@pt/views/pt-viewer/index.vue'),
    meta: {
      title: 'PlayTurbo Preview',
    },
  },
  {
    path: '/legal-agreement',
    name: 'legal-agreement',
    component: () => import('@pt/views/legal-agreement/index.vue'),
  },
  {
    path: '/membership-agreement',
    name: 'membership-agreement',
    component: () => import('@pt/views/membership-agreement/index.vue'),
  },
  {
    path: '/privacy-agreement',
    name: 'privacy-agreement',
    component: () => import('@pt/views/privacy-agreement/index.vue'),
  },
  {
    path: '/auth-agreement',
    name: 'auth-agreement',
    component: () => import('@pt/views/auth-agreement/index.vue'),
  },
  {
    path: '/activities-promotion',
    name: 'activities-promotion',
    component: () => import('@pt/views/activities-promotion/index.vue'),
  },
  {
    path: '/rev-promotion',
    name: 'rev-promotion',
    component: () => import('@pt/views/rev-promotion/index.vue'),
  },
  {
    path: '/data-processing-addendum',
    name: 'data-processing-addendum',
    component: () => import('@pt/views/data-processing-addendum/index.vue'),
  },
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: routerMap,
})

export const asyncRouterMap = [
  {
    path: '/',
    redirect: '/login',
    hidden: true,
  },
  generateConfigRoute(
    {
      title: 'image 2 video',
      pageId: 'image2video',
      isRootRoute: true,
    },
    {
      routeConfig: {
        component: PtLayout,
        hidden: true,
      },
    },
  ),
  generateConfigRoute(
    {
      title: 'avatar 2 video',
      pageId: 'avatar2video',
      isRootRoute: true,
    },
    {
      routeConfig: {
        component: PtLayout,
        hidden: true,
      },
    },
  ),
  generateConfigRoute(
    {
      title: 'subscription',
      pageId: 'subscription',
      isRootRoute: true,
    },
    {
      routeConfig: {
        component: PtLayout,
        hidden: true,
      },
    },
  ),
  // 账号注册
  generateConfigRoute(
    {
      title: '账号注册',
      pageId: 'open_register_trial',
      isRootRoute: true,
    },
    {
      routeConfig: {
        component: PtLayout,
        hidden: true,
      },
    },
  ),
  {
    path: '/home',
    component: PtLayout,
    redirect: '/home/index',
    name: 'home',
    icon: 'front_page',
    meta: {
      title: i18n.t('playTurbo.leftMenu.aside.menu.home'),
      payment: 'free',
    },
    hiddenChildren: true,
    children: [
      {
        path: 'index',
        name: 'home.index',
        component: () => import('@pt/views/home/index.vue'),
        meta: {
          title: i18n.t('playTurbo.leftMenu.aside.menu.home'),
          defaultPath: '/home',
          payment: 'free',
        },
      },
    ],
  },
  demo,
  creativeTemplate,
  myProject,
  dashboard,
  creativeService,
  profile,
  creativeAssets,
  paymentPackage,
  subscriptionPlans,
  videoRecord,
  AccountManagement,
  commonSetting,
  // { path: '*', redirect: '/404', hidden: true },
]
